import { render } from "./ProfileMarkPostContent.vue?vue&type=template&id=1b023372&scoped=true"
import script from "./ProfileMarkPostContent.vue?vue&type=script&lang=js"
export * from "./ProfileMarkPostContent.vue?vue&type=script&lang=js"

import "./ProfileMarkPostContent.vue?vue&type=style&index=0&id=1b023372&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b023372"]])

export default __exports__